export default __webpack_public_path__ + "static/media/certificate-sign.807c8418.svg";